/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Display_Teletext_Spacing_LabelInputs */



/**
* | output |
* | --- |
* | "Teletext Spacing" |
*
* @param {Options_Display_Teletext_Spacing_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_display_teletext_spacing_label = /** @type {((inputs?: Options_Display_Teletext_Spacing_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Display_Teletext_Spacing_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Espacement télétexte")
	if (locale === "de") return /** @type {LocalizedString} */ ("Teletext Spacing")
	if (locale === "it") return /** @type {LocalizedString} */ ("Teletext Spacing")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Teletext Spacing")
	if (locale === "es") return /** @type {LocalizedString} */ ("Espaciado teletext")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Teletext Spacing")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Teletext Spacing")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Teletext Spacing")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Teletext Spacing")
	return /** @type {LocalizedString} */ ("Teletext Spacing")
});